import * as React from 'react';

function IconActionLogoutMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.85474 10.9785L9.09668 8.73657L8.04297 7.68286L4 11.7258L8.04297 15.7688L9.09668 14.7151L6.85474 12.4731H11.0322V10.9785H6.85474ZM11.0322 5V10.9785H15.5161V12.4731H11.0322V18.4517H20V5H11.0322Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconActionLogoutMedium;
